<template>
  <div class="portlet light ">
    <i class="fa fa-arrows-alt arrow-move" aria-hidden="true"></i>
    <div class="module-name">ACTIVITIES AND SERVICES</div>
    <div class="portlet-title tabbable-line">
      <div class="caption">
        <i class="icon-globe font-dark hide"></i>
        <span class="caption-subject font-dark bold uppercase">ACTIVITIES AND SERVICES</span>
      </div>

    </div>
    <vue-spinner v-if="getLoading"></vue-spinner>
    <div class="portlet-body" v-else>
      <!--BEGIN TABS-->
      <div class="tab-content">
        <div class="tab-pane active" id="tab_1_1">
          <div class="scroll-section" style="height: 350px; overflow: hidden;" v-bar>
            <div>
            <ul class="feeds" v-if="user.activities_services.length">
              <li v-for="record in records">
                <router-link :to="{ name: 'Activities and Services Edit', params: { id: ($route.params.id != null) ? $route.params.id : '97', dataid: record.id } }" tag="a">
                  <div class="col1">
                    <div class="cont">
                      <div class="cont-col2">
                        <div class="desc" :class="{'desc--with-status' : ['failed','sent'].includes(record.shared_form_status)}">
                          <i v-if="record.shared_form_status == 'failed'" class="fa fa-exclamation"></i>
                          <i v-if="record.shared_form_status == 'sent'" class="fa fa-share-square-o"></i>
                           {{ record.form_name }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col2">
                    <div class="date">{{ record.created_date.date | formatDateModal }}</div>
                  </div>
                </router-link>
              </li>
            </ul>
              <div v-else>
                <p>No records available.</p>
              </div>
              </div>
          </div>
        </div>
      </div>
      <!--END TABS-->
      &nbsp
    </div>
    <div class="btn-arrow-link pull-right">
      <router-link :to="{ name: 'Activities and Services', params: { id: ($route.params.id != null) ? $route.params.id : '97' } }" tag="a" class="text-warning">VIEW ALL</router-link>
      <i class="icon-arrow-right"></i>
    </div>
    <div class="clearfix"></div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  import Spinner from '@/components/Spinner';
  import _ from 'lodash';

  export default {
    components: {
      'vue-spinner': Spinner
    },
    computed: {
      ...mapGetters({
        user: 'getParticipant',
        getLoading: 'getLoading'
      }),
      records: function (){
        return  this.user.activities_services;
      }
    }
  }
</script>

<style scoped>
  .feeds li .col1 > .cont > .cont-col2 > .desc.desc--with-status {
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// ActivitiesAndServices.vue?34ae4a02